import React, { useEffect, useState } from 'react';
import styles from './Accordion.module.scss';
import PropTypes from 'prop-types';
import {ReactComponent as ChevronIcon} from './Chevron.svg';

const AccordionItem = ({ title, children, isOpen, onToggle }) => {
  return (
    <div className={`${styles.accordionItem} ${isOpen ? styles.openItem : ''}`}>
      <div className={styles.accordionHeader} onClick={onToggle}>
        <h3>{title}</h3>
        <span
          className={`${styles.arrowIcon} ${isOpen ? styles.rotate180 : ''}`}
        >
          <ChevronIcon />
        </span>
      </div>
      <div
        className={`${styles.accordionContent} ${isOpen ? styles.showContent : ''}`}
      >
        {children}
      </div>
    </div>
  );
};

AccordionItem.propTypes = {
  title: PropTypes.any.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func
};

AccordionItem.displayName = "AccordionItem";

const Accordion = ({ children }) => {
  const [openIndex, setOpenIndex] = useState(0); // Track which item is open

  const handleToggle = (index) => {
    // If the same item is clicked, close it; otherwise, open the clicked item
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    window.scrollTo({
      top: 100 + (openIndex * 100),
    });
  }, [openIndex]);

  return (
    <div className={styles.accordion}>
      {React.Children.map(children, (child, index) => {
        return React.cloneElement(child, {
          isOpen: openIndex === index,  // Pass isOpen prop to each AccordionItem
          onToggle: () => handleToggle(index), // Pass toggle function to each AccordionItem
        });
      })}
    </div>
  );
};

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
};

Accordion.displayName = "Accordion";

export { Accordion, AccordionItem };